import { render, staticRenderFns } from "./ProductChangeQuantity.vue?vue&type=template&id=4f22543a&scoped=true&"
import script from "./ProductChangeQuantity.vue?vue&type=script&lang=js&"
export * from "./ProductChangeQuantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f22543a",
  null
  
)

export default component.exports